import { Observable } from 'rxjs';
import { BrandPublicModel } from '../models/brand-public.model';

export abstract class BrandPublicRepository {
    abstract getAll(store?: number): Observable<BrandPublicModel[]>;
}
